import store from '@/store/index'
import router from '@/router/index'
import masterApi from '@/api/master'
import { AdminPageType } from '@/consts/admin'

const redirectToStaffTop = () => router.push({ name: 'staff-top' })

export function useAdminPageAccess(adminType) {
  const fetchCurrentUser = () => store.dispatch('user/getMe')

  const ensureManagerAccess = async () => {
    await fetchCurrentUser()
    if (adminType === AdminPageType.STAFF && !store.getters['user/isStaffTypeManager']) {
      redirectToStaffTop()
      return false
    }
    return true
  }

  const ensureLeaderAccess = async () => {
    await fetchCurrentUser()
    if (adminType === AdminPageType.STAFF
      && !store.getters['user/isStaffTypeManagerOrLeader']) {
      redirectToStaffTop()
      return false
    }
    return true
  }

  const ensureStaffAccess = async () => {
    await fetchCurrentUser()
    const hasStaffRole = store.getters['user/isStaffTypeManagerOrLeader']
      || store.getters['user/isStaffTypeWashFold']
      || store.getters['user/isStaffTypePickupDelivery']
    if (adminType === AdminPageType.STAFF && !hasStaffRole) {
      redirectToStaffTop()
      return false
    }
    return true
  }

  const ensureManagerAccessInMaintenance = async () => {
    await fetchCurrentUser()
    const { data: maintenanceResult } = await masterApi.maintenanceIndex()
    if (maintenanceResult.maint_flg === 1
      && adminType === AdminPageType.STAFF
      && !store.getters['user/isStaffTypeManager']) {
      router.push({ name: 'maintenance' })
      return false
    }
    return true
  }

  return {
    ensureManagerAccess,
    ensureLeaderAccess,
    ensureStaffAccess,
    ensureManagerAccessInMaintenance,
  }
}
